<template>
  <vs-popup
    classContent="popup-example"
    title="Add New Question"
    :active.sync="show"
  >
    <div>
      <div>
        <div class="my-4">
          <label>Type</label>
          <vs-select v-model="form.question_type">
            <vs-select-item
              :key="index"
              :value="option.value"
              :text="option.text"
              v-for="(option, index) in options"
            />
          </vs-select>
        </div>
        <div class="my-4">
          <label>Title</label>
          <vs-input v-model="form.question_title" style="width: 90%" />
        </div>

        <div class="my-2">
          <label>Status</label>
          <vs-switch class="mt-2" v-model="form.publish_status" />
        </div>
        <div class="my-4">
          <label>Is Required?</label>
          <vs-switch class="mt-2" v-model="form.is_required" />
        </div>

        <div class="my-4">
          <label>Page Filter</label>
          <vs-input v-model="form.page_filter" style="width: 90%" />
        </div>
      </div>
      <vs-divider />
      <div class="text-right">
        <vs-button style="display: inline-block" class="mr-2" @click="submit"
          >Save</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>
<script>
import { mapState } from "vuex";
import Service from "@/services";
import { countries } from "@/utils/Countries";

export default {
  components: {},
  props: {
    showDialog: false,
    form_id: null,
    event_id: null,
  },
  data: () => ({
    options: [
      { text: "Short answer", value: "text" },
      { text: "Number", value: "number" },
      { text: "National ID", value: "citizenid" },
      { text: "Paragraph", value: "textarea" },
      { text: "Date", value: "date" },
      { text: "Birthdate", value: "birthdate" },
      { text: "Multiple choice", value: "radio" },
      { text: "Checkboxes", value: "checkbox" },
      { text: "Dropdown", value: "select" },
      { text: "Country", value: "country" },
      { text: "Province (Thailand)", value: "province-thailand" },
      { text: "Image Upload", value: "uploadimage" },
      { text: "Rank", value: "rank" },
      // { text: "Location (latitude, longitude)", value: "map" },
      // { text: "Travel Distance", value: "distance" },
      { text: "Divider", value: "divider" },
    ],
    form: {
      form_id: null,
      event_id: null,
      question_title: "",
      question_shortdesc: "",
      question_longdesc: "",
      question_image: null,
      is_anonymous: "",
      datetime_start: "",
      datetime_end: "",
      question_type: "text",
      options_json: [
        {
          value: "Red",
          publish_status: true,
        },
      ],
      validations: [
        {
          rule: "min",
          value: 1,
        },
        {
          rule: "max",
          value: 2,
        },
      ],
      is_required: "",
      auth_required: "",
      publish_status: true,
      listing_status: true,
      weight: 1,
      current_round: 1,
      page_filter: null,
      custom_field1: "",
      custom_field2: "",
      custom_field3: "",
      custom_field4: "",
      custom_field5: "",
    },
    fields: [],
    countries: [],
  }),
  computed: {
    show: {
      get() {
        if (this.showDialog) {
          this.form = {
            form_id: null,
            event_id: null,
            question_title: "",
            question_shortdesc: "",
            question_longdesc: "",
            question_image: null,
            is_anonymous: "",
            datetime_start: "",
            datetime_end: "",
            question_type: "text",
            options_json: [],
            validations: [],
            is_required: "",
            auth_required: "",
            publish_status: true,
            listing_status: true,
            weight: 1,
            current_round: 1,
            page_filter: null,
            custom_field1: "",
            custom_field2: "",
            custom_field3: "",
            custom_field4: "",
            custom_field5: "",
          };
        }
        return this.showDialog;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    submit() {
      this.form.form_id = this.form_id;
      this.form.event_id = this.event_id;
      this.$vs.loading();
      Service.Question.addQuestion(this.form).then((res) => {
        this.$vs.loading.close();
        this.$emit("submit");
      });
    },
  },
};
</script>
